import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PatientDemographicsService } from '../../../../api/services/patient-demographics.service';
import { PatientDemographic } from '../../../../api/models/patient-demographic';
import { MessageService } from 'primeng/api';
import { CareFinitySession } from '../../../services/CareFinitySession';


@Component({
  selector: 'app-patient-demographic',
  templateUrl: './patient-demographic.component.html',
  styleUrl: './patient-demographic.component.css'
})


export class PatientDemographicComponent implements OnInit {
    patientForm!: FormGroup;
    patientId = sessionStorage.getItem('ptId');     // could come from route param
    practiceId = localStorage.getItem('EmrPracticeId');   // could come from logged-in user/session

    genderOptions = [
        { key: 'M', value: 'Male' },
        { key: 'F', value: 'Female' },
        { key: 'Other', value: 'Other' },
    ]


    @Output() cancel = new EventEmitter<void>();

   
    constructor(private fb: FormBuilder, private patientService: PatientDemographicsService, private messageService: MessageService) {

    }

    ngOnInit(): void {
        this.patientForm = this.fb.group({
            firstName: ['', Validators.required],
            middleName: [''],
            lastName: ['', Validators.required],
            gender: [''],
            homeAddressLine1: [''],
            homeCity: [''],
            homeState: [''],
            homePostalCode: [''],
            homeCountry: [''],
            homeTelephone: ['']
        });

        // Load patient from API
        if (CareFinitySession?.practiceSettings?.showPatientDemographics) {
            this.patientService.patientDemographicsGetById({ patientId: this.patientId, practiceId: this.practiceId }).subscribe(patient => {
                this.patientForm.patchValue(patient);
            });
        }
       
    }

    onSubmit(): void {
        if (this.patientForm.valid) {
            const pat: PatientDemographic = this.patientForm.value;
            this.patientService.patientDemographicsUpdate({ patientId: this.patientId, practiceId: this.practiceId, body: pat }).subscribe({
                next: (result) => {
                    console.log(result);
                    this.messageService.add({
                        key: 'alertToast',
                        severity: 'success',
                        summary: 'Confirmation',
                        detail: `Patient Demographic  are ${true ? 'updated' : 'added'} successfully`,
                        life: 5000,
                    });
                },
                error: (err) => {
                    this.messageService.add({
                        key: 'alertToast',
                        severity: 'error',
                        summary: 'ERROR',
                        detail: err.error,
                        life: 7000,
                    });
                },
                complete: () => {
                    setTimeout(() => {
                        window.location.reload();
                    },1000);
                },
            });
        }
    }



    onCancelClick() {
        this.cancel.emit(); // notify parent
    }


}
